import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../../axiosinterceptor";

const coder_screen_get_api =
"/coding_screen_workflow_get_dashboard_data";
const coder_queue_filters_api =
  "/workflow_coding_screen_get_filters_queue_data";
const coder_stats_api =
  "/stats_coding_screen_workflow";
const coder_speciality_api =
  "/workflow_coding_screen_get_filters_speciality_data";
const coder_priority_status_api =
  "/workflow_coding_screen_get_filters_status_priority_data";
const coder_urnumber_api =
  "/coding_screen_workflow_urnumber_filters_data";
const coder_search_api =
  "/coding_screen_workflow_get_dashboard_data_bysearch";
const user_preference_check_api =
  "/check_user_has_code_accelerate_assist_permission";
const coder_queues_api='/coding_screen_get_queue_data'
// Async thunk to fetch episode,queues data
export const fetchCodersData = createAsyncThunk(
  "queue/fetchEpisodes",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(coder_screen_get_api, payload);

      // console.log("Coder API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchCoderQueueFilters = createAsyncThunk(
  "queue/fetchCodersQueueFilters",
  async (pageNumber, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${coder_queue_filters_api}?page_number=${pageNumber}`
      );
      // console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchStatsData = createAsyncThunk(
  "queue/fetchStatsData",
  async (payload, thunkAPI) => {
    const newPayload={
      body:payload
    }
    try {
      const response = await axiosInstance.post(coder_stats_api, newPayload);

      // console.log("Coder stats Response",payload);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchCoderSpecialityData = createAsyncThunk(
  "queue/fetchCoderSpecialityData",
  async (pageNumber, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${coder_speciality_api}?page_number=${pageNumber}`
      );
      // console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchCoderStatusPriority = createAsyncThunk(
  "queue/fetchCoderStatusPriority",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(coder_priority_status_api);
      // console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchCoderURNumber = createAsyncThunk(
  "queue/fetchCoderURNumber",
  async (pageNumber, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${coder_urnumber_api}?page_number=${pageNumber}`
      );
      // console.log("Queue Fil API Response", response.data);

      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);

export const fetchSearchedCoderDetails = createAsyncThunk(
  "queue/fetchSearchedCoderDetails",
  async ({ searchedTerm, pageNumber }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${coder_search_api}?search=${searchedTerm}&page=${pageNumber}`
      );
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchUserPreferences = createAsyncThunk(
  "queue/fetchUserPreferences",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(user_preference_check_api);
      console.log("Queue Fil API Response", response.data);

      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
export const fetchCodersQueueData = createAsyncThunk(
  "queue/fetchCodersQueueData",
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(coder_queues_api, payload);
      // console.log("Coder stats Response",payload);
      // Remove JSON.parse, since response.data is already an object
      return response.data;
    } catch (error) {
      console.error("Error fetching queue list:", error); // Log errors too
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch queue list"
      );
    }
  }
);
const CoderScreenSlice = createSlice({
  name: "coderscreenqueue",
  initialState: {
    codersData: [],
    loadingCodersData: false,
    errorCodersData: null,
    queueFiltersData: [],
    loadingQueueFiltersData: null,
    errorQueueFiltersData: [],
    statsData: [],
    loadingStatsData: false,
    errorStatsData: null,
    codersSpeciality: {
      codersSpecialityData: [],
      isSpecialityPageTrue: true,
      specialityPageNumber: 0,
    loadingSpecialityData: false,
    errorsSpecialityData: null,
    },
    codersStatusPriorityData: [],
    loadingCodersStatusPriorityData: false,
    errorsCodersStatusPriorityData: null,
    coderURNumberData: [],
    loadingcoderURNumberData: false,
    errorscoderURNumberData: null,
    codersSearchedData: [],
    loadingcodersSearchedData: false,
    errorscodersSearchedData: null,
    preferencesData:[],
    loadingPreferencesData:false,
    errorsPreferencesData:null,
    coderQueuesData:[],
    loadingCoderQueuesData:false,
    errorsCoderQueuesData:null,
    coderFilter: {
      separation_date_from: null,
      separation_date_to: null,
      speciality: [],
      queue: [],
      queue_priority: [],
      status: [],
      page_number: 1,
      ur_number: [],
      search_term:""
    }
  },
  reducers: {
    resetSearchedCodersData: (state) => {
      state.codersSearchedData = [];
      state.loadingcodersSearchedData = false;
      state.errorscodersSearchedData = null;
    },
    updateSpecialityPageNumber: (state, action) => {
      state.codersSpeciality.specialityPageNumber = action.payload
    },
    updateUserAssginedFilters: (state, action) => {
      state.coderFilter = {
        ...state.coderFilter,
        ...action.payload,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Queue List
      .addCase(fetchCodersData.pending, (state) => {
        state.loadingCodersData = true;
        state.errorCodersData = null;
      })
      .addCase(fetchCodersData.fulfilled, (state, action) => {
        state.loadingCodersData = false;
        state.codersData = action.payload;
      })
      .addCase(fetchCodersData.rejected, (state, action) => {
        state.loadingCodersData = false;
        state.errorCodersData = action.payload;
      })
      // Fetch CoderStats Data
      .addCase(fetchStatsData.pending, (state) => {
        state.loadingStatsData = true;
        state.errorStatsData = null;
      })
      .addCase(fetchStatsData.fulfilled, (state, action) => {
        state.loadingStatsData = false;
        state.statsData = action.payload;
      })
      .addCase(fetchStatsData.rejected, (state, action) => {
        state.loadingStatsData = false;
        state.errorStatsData = action.payload;
      })
      //Fetch coder specialities
      .addCase(fetchCoderSpecialityData.pending, (state) => {
        state.codersSpeciality.loadingSpecialityData = true;
        state.codersSpeciality.errorsSpecialityData = null;
      })
      .addCase(fetchCoderSpecialityData.fulfilled, (state, action) => {
        state.codersSpeciality.loadingSpecialityData = false;
        // state.codersSpecialityData = action.payload;
      state.codersSpeciality.codersSpecialityData = [
      ...state.codersSpeciality.codersSpecialityData,
      ...action.payload?.specialties || []
];
      const isValidPage = action.payload ? action.payload?.has_more : false;
      state.codersSpeciality.isSpecialityPageTrue = isValidPage || false;
      })
      .addCase(fetchCoderSpecialityData.rejected, (state, action) => {
        state.codersSpeciality.loadingSpecialityData = false;
        state.codersSpeciality.errorsSpecialityData = action.payload;
      })
      //fetch status and priority
      .addCase(fetchCoderStatusPriority.pending, (state) => {
        state.loadingCodersStatusPriorityData = true;
        state.errorsCodersStatusPriorityData = null;
      })
      .addCase(fetchCoderStatusPriority.fulfilled, (state, action) => {
        state.loadingCodersStatusPriorityData = false;
        state.codersStatusPriorityData = action.payload;
      })
      .addCase(fetchCoderStatusPriority.rejected, (state, action) => {
        state.loadingCodersStatusPriorityData = false;
        state.errorsCodersStatusPriorityData = action.payload;
      })
      //Fetch searched data
      .addCase(fetchCoderURNumber.pending, (state) => {
        state.loadingcoderURNumberData = true;
        state.errorscoderURNumberData = null;
      })
      .addCase(fetchCoderURNumber.fulfilled, (state, action) => {
        state.loadingcoderURNumberData = false;
      
        const newEpisodes = action.payload.episodes_with_ur_number;
        const currentPage = action.meta.arg; // page number passed to the thunk
      
        if (currentPage === 1 || !state.coderURNumberData) {
          // If it's the first page or no data yet, replace
          state.coderURNumberData = {
            episodes_with_ur_number: newEpisodes,
            has_more: action.payload.has_more,
            total_count: action.payload.total_count,
          };
        } else {
          // Otherwise, append to the existing episodes
          state.coderURNumberData.episodes_with_ur_number.push(...newEpisodes);
          state.coderURNumberData.has_more = action.payload.has_more;
          state.coderURNumberData.total_count = action.payload.total_count;
        }
      })
      .addCase(fetchCoderURNumber.rejected, (state, action) => {
        state.loadingcoderURNumberData = false;
        state.errorscoderURNumberData = action.payload;
      })
      
      .addCase(fetchSearchedCoderDetails.pending, (state) => {
        state.loadingcodersSearchedData = true;
        state.errorscodersSearchedData = null;
      })
      .addCase(fetchSearchedCoderDetails.fulfilled, (state, action) => {
        state.loadingcodersSearchedData = false;
        state.codersSearchedData = action.payload;
      })
      .addCase(fetchSearchedCoderDetails.rejected, (state, action) => {
        state.loadingcodersSearchedData = false;
        state.errorscodersSearchedData = action.payload;
      })
    //fetch preferences
    .addCase(fetchUserPreferences.pending, (state) => {
      state.loadingPreferencesData = true;
      state.errorsPreferencesData = null;
    })
    .addCase(fetchUserPreferences.fulfilled, (state, action) => {
      state.loadingPreferencesData = false;
      state.preferencesData = action.payload;
    })
    .addCase(fetchUserPreferences.rejected, (state, action) => {
      state.loadingPreferencesData = false;
      state.errorsPreferencesData = action.payload;
    })
    //fetch Queues Data
    .addCase(fetchCodersQueueData.pending, (state) => {
      state.loadingCoderQueuesData = true;
      state.errorsCoderQueuesData = null;
    })
    .addCase(fetchCodersQueueData.fulfilled, (state, action) => {
      state.loadingCoderQueuesData = false;
      state.coderQueuesData = action.payload;
    })
    .addCase(fetchCodersQueueData.rejected, (state, action) => {
      state.loadingCoderQueuesData = false;
      state.errorsCoderQueuesData = action.payload;
    })
  },
});
export const { resetSearchedCodersData, updateUserAssginedFilters, updateSpecialityPageNumber } = CoderScreenSlice.actions;
export default CoderScreenSlice.reducer;